class ProductRecommendations extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.fetchRecommendations()
  }

  fetchRecommendations () {
    fetch(
      `${this.baseUrl}?section_id=${this.sectionId}&product_id=${this.productId}&limit=${this.limit}&intent=related`,
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector('product-recommendations')

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  get baseUrl () {
    return this.dataset.baseUrl
  }

  get limit () {
    return this.dataset.limit
  }

  get productId () {
    return this.dataset.productId
  }

  get sectionId () {
    return this.dataset.sectionId
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations)
}
